import { render, staticRenderFns } from "./SurveyQuestionDetails.vue?vue&type=template&id=4f4695bf&scoped=true"
import script from "./SurveyQuestionDetails.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionDetails.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionDetails.vue?vue&type=style&index=0&id=4f4695bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4695bf",
  null
  
)

export default component.exports